import { NavLink } from 'react-router-dom';
import Pages from 'components/shared/Pages';
import { GetPathForPage } from 'components/shared/AppRoutes';
import React from 'react';

const TopLeftLogo = () => (
  <NavLink to={{ pathname: GetPathForPage(Pages.DashBoard) }}>
    <div className="flex flex-shrink-0 items-center">
      <svg
        version="1.0"
        width="40.000000"
        height="35.000000"
        viewBox="0 0 100.000000 100.000000"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          transform="matrix(0.025534, 0, 0, -0.025534, 3.30197, 98.058701)"
          stroke="none"
          fill="#fff"
        >
          <path d="M3279 3355 c-222 -163 -408 -300 -413 -305 -6 -6 6 -61 34 -150 24 -77 41 -142 39 -144 -2 -1 -152 -110 -334 -241 -718 -519 -1121 -813 -1138 -833 -24 -27 -33 -94 -17 -132 25 -59 111 -88 172 -56 14 8 284 202 600 432 671 489 849 618 865 628 7 4 43 -16 85 -47 40 -30 92 -66 115 -81 l42 -28 413 302 c227 165 414 305 416 310 2 4 -105 34 -238 66 -132 32 -245 61 -251 65 -8 4 -6 67 5 220 9 118 18 231 21 252 3 20 2 37 -3 37 -5 0 -190 -133 -413 -295z" />
          <path d="M1470 3009 c-190 -13 -337 -53 -514 -141 -169 -83 -271 -160 -420 -316 -126 -133 -260 -368 -311 -547 -83 -290 -72 -618 31 -891 71 -192 186 -364 343 -517 271 -263 598 -396 974 -397 229 0 415 43 622 144 344 168 592 447 713 801 115 339 101 713 -39 1024 -22 48 -32 61 -41 54 -7 -6 -96 -70 -198 -143 -102 -73 -189 -136 -194 -141 -5 -4 2 -44 15 -91 21 -73 24 -104 24 -248 -1 -189 -11 -237 -88 -395 -113 -232 -330 -409 -587 -477 -71 -19 -109 -23 -230 -22 -128 0 -155 4 -235 28 -115 35 -180 64 -266 122 -178 118 -316 317 -375 540 -28 105 -25 322 4 434 67 248 237 462 462 579 284 148 654 130 914 -45 l66 -44 187 136 c104 75 196 144 206 154 18 16 16 19 -45 70 -75 64 -200 146 -283 187 -138 69 -354 130 -489 139 -39 3 -87 6 -106 7 -19 2 -82 0 -140 -4z" />
          <path d="M1451 2175 c-267 -61 -454 -300 -452 -575 1 -157 50 -276 164 -396 115 -122 244 -176 419 -175 115 1 160 12 267 66 209 105 342 362 305 588 -4 20 -9 37 -13 37 -3 0 -103 -71 -221 -157 -286 -207 -316 -221 -426 -188 -157 47 -220 224 -130 363 12 20 114 101 248 198 125 91 230 169 233 174 3 5 -7 16 -22 23 -91 47 -264 66 -372 42z" />
        </g>
      </svg>
      <span className="text-4xl font-extrabold tracking-tight text-gray-100 sm:text-4xl md:text-4xl lg:text-4xl xl:text-4xl">
        Aimly
      </span>
    </div>
  </NavLink>
);

export default TopLeftLogo;
